import { useState, useEffect } from "react";
import { API_URL } from "../config";
import { mergeCheckoutTextsWithDefaults } from "../utils/mergeCheckoutTexts";

const DEFAULTS = {
  tituloPagina: "Finalizar Compra",
  subtituloPagina:
    "Verifica los detalles de tu inscripción antes de procesar el pago.",
  caracteristicas: ["Acceso inmediato", "100% Online"],
  beneficios: [
    {
      titulo: "Calidad Garantizada",
      descripcion: "Miles de alumnos confían en nuestra plataforma.",
    },
    {
      titulo: "Garantía de 15 días",
      descripcion: "Si no te convence, te lo devolvemos sin preguntas.",
    },
  ],
  textoSeguridad: "Procesamiento encriptado de 256-bits",
  tituloCarritoVacio: "Tu carrito está vacío",
  descripcionCarritoVacio:
    "Parece que aún no has añadido ningún curso. ¡Descubre nuestro catálogo y empieza a aprender!",
};

const useCheckoutTexts = () => {
  const [texts, setTexts] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    fetch(`${API_URL}/api/configuracion/texto-carrito`, {
      credentials: "include",
      signal: controller.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch checkout texts");
        return res.json();
      })
      .then((data) => {
        if (!controller.signal.aborted) {
          setTexts(mergeCheckoutTextsWithDefaults(data, DEFAULTS));
        }
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("useCheckoutTexts: falling back to defaults", err);
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, []);

  return { texts, loading };
};

export { DEFAULTS as CHECKOUT_TEXT_DEFAULTS };
export default useCheckoutTexts;
